export default __webpack_public_path__ + "static/media/Lonely-Woman.91b80633.jpg";